<template>
  <div class="copyright">
    <van-nav-bar
      :style="{ background: color }"
      left-arrow
      fixed
      @click-left="$router.go(-1)"
      :title="$t('ContactUs.contact')"
    ></van-nav-bar>
    <div class="content">
      <div class="card">
        <div class="title">{{ $t("ContactUs.info") }}</div>
        <div class="card_content">
          <van-row class="icons">
            <van-col span="4">
              <svg-icon
                iconClass="address"
                class="icon"
                :style="{ color: color }"
              />
            </van-col>
            <van-col span="8">
              <svg-icon
                iconClass="user"
                class="icon"
                :style="{ color: color }"
              />
            </van-col>
            <van-col span="9">
              <svg-icon
                iconClass="phone"
                class="icon"
                :style="{ color: color }"
              />
            </van-col>
          </van-row>
          <van-row v-for="(item, index) in contacts" :key="index">
            <van-col span="4">{{ item.area }}</van-col>
            <van-col span="8">{{ item.name }}</van-col>
            <van-col span="9" @click="callPhone(item.phone)">{{
              item.phone
            }}</van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contacts: [
        {
          area: this.$t("ContactUs.taiwan"),
          name: this.$t("ContactUs.lin"),
          phone: "+886 914143434"
        },
        {
          area: this.$t("ContactUs.taiwan"),
          name: this.$t("ContactUs.tian"),
          phone: "+886 979966001"
        },
        {
          area: this.$t("ContactUs.hongkong"),
          name: this.$t("ContactUs.chan"),
          phone: "+852 96438110"
        }
        // {
        // 	area:this.$t('ContactUs.zhuhai'),
        // 	name:this.$t('ContactUs.lin'),
        // 	phone:'13714082522',
        // },
        // {
        // 	area:this.$t('ContactUs.shanwei'),
        // 	name:this.$t('ContactUs.chen'),
        // 	phone:'15019424243',
        // },
        // {
        // 	area:this.$t('ContactUs.shenzhen'),
        // 	name:this.$t('ContactUs.qiu'),
        // 	phone:'18370777559',
        // },
        // {
        // 	area:this.$t('ContactUs.shantou'),
        // 	name:this.$t('ContactUs.misschen'),
        // 	phone:'18666682811',
        // },
        // {
        // 	area:this.$t('ContactUs.dongguan'),
        // 	name:this.$t('ContactUs.liu'),
        // 	phone:'15817717507',
        // },
        // {
        // 	area:this.$t('ContactUs.guilin'),
        // 	name:this.$t('ContactUs.wang'),
        // 	phone:'18575370602',
        // },
        // {
        // 	area:this.$t('ContactUs.fuzhou'),
        // 	name:this.$t('ContactUs.shi'),
        // 	phone:'15060695780',
        // },
      ],
      color: ""
    };
  },
  mounted() {
    this.color = sessionStorage.getItem("colorCode");
  },
  methods: {
    // 调用拨号功能
    callPhone(phoneNumber) {
      window.location.href = "tel://" + phoneNumber;
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-col {
  text-align: center;
}
.copyright {
  width: 100%;
  height: 100vh;
  background: #bbbbbb;
  font-size: 16px;
}
.title {
  color: #000;
  font-weight: bold;
  border-bottom: 1px solid #bbbbbb;
  padding: 10px 0px;
}
.content {
  color: #707070;
  padding-top: 46px;
}
.van-col {
  padding-top: 10px;
}
.icons {
  border-bottom: 1px solid #bbbbbb;
  padding: 10px 0px;
}
.logo {
  background: #000;
  padding-top: 46px;
}
.card {
  background: #fff;
  margin: 10px;
  padding: 10px 20px;
  box-shadow: 0px 0px 10px #979797;
  border-radius: 10px;
}
.icon {
  width: 25px;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/reserve/ContactUs.vue